import { SWATCHES } from './onboarding'

const TEMPLATES = {
  professional_v1: '7d4cf99b-c2bc-4790-996c-ba9f6bfd1bb7',
  professional_v2: '75a3d801-89b2-4ac5-8fdc-a889eb7cfac1',
  playful_v1: '6e2b0262-980d-4ada-b5ab-ec77816220e3',
  playful_v2: '0c3f5491-7594-43d0-9fa8-b42877c50732',
  modern_v1: '9937a286-32ea-4e6e-88f4-7446c4dc738f',
  modern_v2: '5ed43ef1-e39f-4279-93a0-c899246ae7c0',
  bold_v1: '26ae90a0-2d33-4841-876b-b656bbbb707d',
  bold_v2: '043808e9-5440-4359-a5e0-c82e08dd1cca',
  // classic_v1_no_grid: '23210ee7-ef96-40f7-9e34-52fd9385e5cd',
  classic_v1: '23210ee7-ef96-40f7-9e34-52fd9385e5cd',
  classic_v2: '9cdab1fc-9b71-4a2b-86e4-1fdf6273a4c2'
};

const { 
  playful: PlayfulSwatches, 
  modern: ModernSwatches, 
  professional: ProfessionalSwatches, 
  bold: BoldSwatches, 
  classic: ClassicSwatches 
} = SWATCHES;

export const TEMPLATE_VERSIONS = () => ({
  professional: {
    v1: { defaultTemplate: TEMPLATES.professional_v1, layouts: [], defaultSwatch: ProfessionalSwatches.v1.default },
    v2: { defaultTemplate: TEMPLATES.professional_v2, layouts: [], defaultSwatch: ProfessionalSwatches.v2.default },
  },
  playful: {
    v1: { defaultTemplate: TEMPLATES.playful_v1, layouts: [], defaultSwatch: PlayfulSwatches.v1.default },
    v2: { defaultTemplate: TEMPLATES.playful_v2, layouts: [], defaultSwatch: PlayfulSwatches.v2.default },
  },
  modern: {
    v1: { defaultTemplate: TEMPLATES.modern_v1, layouts: [], defaultSwatch: ModernSwatches.v1.default },
    v2: { defaultTemplate: TEMPLATES.modern_v2, layouts: [], defaultSwatch: ModernSwatches.v2.default },
  },
  bold: {
    v1: { defaultTemplate: TEMPLATES.bold_v1, layouts: [], defaultSwatch: BoldSwatches.v1.default },
    v2: { defaultTemplate: TEMPLATES.bold_v2, layouts: [], defaultSwatch: BoldSwatches.v2.default },
  },
  classic: {
    v1: { 
      defaultTemplate: TEMPLATES.classic_v1, 
      layouts: [], 
      defaultSwatch: ClassicSwatches.v1.default 
    },
    v2: { defaultTemplate: TEMPLATES.classic_v2, layouts: [], defaultSwatch: ClassicSwatches.v2.default },
  },
});
